import React from 'react';
import ReactDOM from 'react-dom/client';
import './App.css';
import App from './App.jsx';
import DriverView from './DriverView.jsx';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const pathname = window.location.pathname || '';
const RootComponent = pathname.startsWith('/driver-view-v2/') ? DriverView : App;

root.render(
  <React.StrictMode>
    <RootComponent />
  </React.StrictMode>
);
